import React from 'react';
import { Icon, Popover, Popconfirm, Card } from 'antd';
import SERVER_URL from '../Global';
import { Link } from 'react-router-dom';

class CardLite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comp: this.props.company,
            user: this.props.token,
            modalDelete: false
        };

        this.revertComp = this.revertComp.bind(this);
    }

    revertComp() {
        fetch(
            `${SERVER_URL + "api/company/restore/" + this.state.comp.companyId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
            }
        ).then(response => response.json())
        .then(res => {
            this.props.crossFetch(this.state.comp.companyId);
        })
    }

    deleteComp(id, definitive) {
        if (definitive == 1) {
            //eliminazione soft
            fetch(
                `${SERVER_URL + 'api/company/' + id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).then(() => {
                this.setState({ modalDelete: false })
                this.props.crossFetch(id);
            })
        }
        else {
            //eliminazione hard
            fetch(
                `${SERVER_URL + 'api/company/hard/' + id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).then(response => response.json())
            .then(res => {
                this.setState({ modalDelete: false })
                this.props.crossFetch(id);
            })
        }
    }

    render() {
        let comp = this.state.comp

        let image = ''

        var checkImage = true;
        if (!comp.companyImage || comp.companyImage == null || comp.companyImage == 'null') {
            var iniziale = comp.name.charAt(0);
            var checkImage = false;
        } else {
            image = 'data:' + comp.imageType + ';base64,' + comp.companyImage
        }

        let vari = []

        let immagine = checkImage ? <div onClick={() => this.props.getDetail(comp.companyId, false)} style={{ backgroundImage: 'url(' + `${image}` + ')' }} className="trueImage"></div> : <div onClick={() => this.props.getDetail(comp.companyId, false)} className="fakeImage">{iniziale}</div>;

        /*let phoneNumber = <div className="listContacts">{comp.offices.map(o => {
            return (
                o.brHrRoleOfficies.map(br => {
                    return (
                        br.contacts.map(con => {
                            if (con.property_TrValue === 3) {
                                return (<p className={"icona_" + con.propertyTr.queryTip} key={con.contactId}>{con.text}</p>)
                            }
                        })
                    )
                })
            )
        })
        }
        </div>*/

        let linea = comp.status === 2 ? 'lineaThrough' : ''

        var sorted_cat = comp.brCompanyCategories.sort((a, b) => {
            return new Date(a.created).getTime() -
                new Date(b.created).getTime()
        })

        let category =
            <div>
                <h4 className="categoryNameList">
                    {
                        sorted_cat.map(cat => {
                            let parentCat = cat.companyCategories.companyCategoryParent != null ? cat.companyCategories.companyCategoryParent.name + " - " : null
                            return <span key={cat.catId}><i>{parentCat}</i>{cat.companyCategories.name}</span>
                        })
                    }
                </h4>
            </div>

        function addToBookmarks() {
            var bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]");
            var id = comp.companyId

            if (bookmarked.includes(id)) {
                for (var i = 0; i < bookmarked.length; i++) {
                    if (bookmarked[i] === id) {
                        bookmarked.splice(i, 1);
                        localStorage.setItem('bookmarked', bookmarked);
                    }
                }
                document.getElementById("icona" + id).childNodes[0].childNodes[0].style.fill = "grey";
            }
            else {
                bookmarked.push(id);
                localStorage.setItem('bookmarked', bookmarked);
                document.getElementById("icona" + id).childNodes[0].childNodes[0].style.fill = "#ffa500";
            }
        }

        if (localStorage.getItem("bookmarked") === null) {
            localStorage.setItem("bookmarked", [])
        }

        if (localStorage.getItem("bookmarked").indexOf(",") > -1) {
            var bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]")
        }
        else if (localStorage.getItem("bookmarked") > 0) {
            var bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]")
        }
        else {
            var bookmarked = []
        }

        let bookmark = bookmarked.includes(comp.companyId) ?
            <Popover content="Bookmark" trigger="hover">
                <Icon onClick={addToBookmarks} id={"icona" + comp.companyId} type="star" style={{ color: "#FFA500" }} className="bookmark actionIcon" />
            </Popover>
            :
            <Popover content="Bookmark" trigger="hover">
                <a onClick={addToBookmarks}>
                    <Icon id={"icona" + comp.companyId} type="star" className="bookmark actionIcon" />
                </a>
            </Popover>

        let deletedComp = () => (
            <svg height="25px" viewBox="-6 1 511 511.99892" width="25px">
                <path d="m77.339844 106.769531c5.738281-2.351562 8.050781-9.472656 4.496094-14.804687-2.523438-3.855469-7.726563-5.574219-12.160157-3.683594-4.574219 1.90625-6.910156 6.703125-5.992187 11.199219 1.265625 6.234375 7.871094 9.699219 13.65625 7.289062zm0 0" />
                <path d="m458.371094 227.898438h-22.292969v-12.730469c0-14.855469-12.085937-26.945313-26.941406-26.945313-76.078125.316406-73.566407-.707031-79.628907.914063v-130.722657c0-77.742187-329.007812-78.027343-329.007812 0v259.816407 84.265625c0 55.550781 172.613281 73.277344 270.390625 45.757812v11.28125c0 28.925782 23.539063 52.464844 52.46875 52.464844h98.871094c28.929687 0 52.464843-23.539062 52.464843-52.464844v-154.929687c13.757813-3.703125 23.914063-16.277344 23.914063-31.1875v-5.28125c0-22.1875-18.050781-40.238281-40.238281-40.238281zm-128.828125-12.730469c0-3.8125 3.097656-6.910157 6.910156-6.910157h72.683594c3.808593 0 6.910156 3.101563 6.910156 6.910157v12.730469h-86.503906zm-81.199219 42.589843c-.632812 2.363282-1.054688 4.917969-1.230469 7.105469-55.886719 11.433594-135.492187 10.476563-188.347656-6.128906-26.410156-8.300781-38.230469-18.417969-38.230469-24.769531v-54.695313c10.328125 6.691407 23.144532 11.621094 34.835938 15.136719 73.660156 22.148438 203.332031 17.761719 254.101562-15.136719v48.628907c-18.480468.015624-51.871094-4.839844-61.128906 29.859374zm22.546875 46.855469v38.484375c-57.21875 17.871094-152.679687 18.578125-212.125-.097656-26.410156-8.300781-38.234375-18.417969-38.234375-24.769531v-54.695313c22.882812 14.867188 59.898438 22.273438 86.980469 25.582032 44.335937 5.429687 97.070312 4.597656 141.578125-4.207032 3.683594 9.640625 11.875 17.03125 21.800781 19.703125zm-212.125-270.96875c58.421875-18.355469 154.039063-18.359375 212.472656 0 26.410157 8.300781 38.234375 18.417969 38.234375 24.769531 0 6.347657-11.824218 16.46875-38.234375 24.765626-45.394531 14.265624-108.191406 16.421874-156.503906 11.070312-5.488281-.601562-10.449219 3.355469-11.0625 8.851562-.605469 5.5 3.359375 10.453126 8.855469 11.058594 55.550781 6.15625 152.023437 3.011719 196.945312-26.175781v61.714844c0 6.347656-11.824218 16.46875-38.234375 24.769531-58.421875 18.355469-154.039062 18.359375-212.472656 0-26.410156-8.300781-38.234375-18.421875-38.234375-24.769531v-61.722657c3.6875 2.40625 7.824219 4.632813 11.777344 6.488282 5.011718 2.347656 10.972656.191406 13.324218-4.816406 2.347657-5.007813.191407-10.972657-4.816406-13.320313-14.957031-7.015625-20.285156-13.855469-20.285156-17.914063 0-6.351562 11.824219-16.46875 38.234375-24.769531zm0 393.621094c-26.410156-8.300781-38.234375-18.421875-38.234375-24.769531v-54.695313c55.609375 36.132813 186.417969 34.222657 250.359375 16.191407v63.378906c-57.53125 17.96875-152.992187 18.472656-212.125-.105469zm395.894531 32.269531c0 17.882813-14.546875 32.429688-32.429687 32.429688h-98.875c-17.882813 0-32.429688-14.546875-32.429688-32.429688v-24.921875c0-.007812 0-.019531 0-.027343v-128.871094h163.734375zm23.914063-186.117187c0 6.761719-5.5 12.261719-12.261719 12.261719-10.601562 0-175.195312 0-185.402344 0-.703125-.117188-5.90625.800781-10.300781-3.59375-4.992187-4.996094-3.230469-10.851563-3.59375-13.949219 0-10.445313 7.964844-19.0625 18.136719-20.101563 1.90625-.191406.546875-.066406 33.828125-.101562h139.390625c11.140625 0 20.203125 9.0625 20.203125 20.203125zm0 0" />
                <path d="m372.792969 477.308594c5.53125 0 10.019531-4.484375 10.019531-10.015625v-136.90625c0-5.53125-4.488281-10.015625-10.019531-10.015625s-10.015625 4.484375-10.015625 10.015625v136.90625c0 5.53125 4.484375 10.015625 10.015625 10.015625zm0 0" />
                <path d="m324.40625 454.136719c5.535156 0 10.019531-4.488281 10.019531-10.019531v-90.554688c0-5.53125-4.484375-10.015625-10.019531-10.015625-5.53125 0-10.015625 4.484375-10.015625 10.015625v90.554688c0 5.53125 4.484375 10.019531 10.015625 10.019531zm0 0" />
                <path d="m421.179688 454.136719c5.53125 0 10.015624-4.488281 10.015624-10.019531v-90.554688c0-5.53125-4.484374-10.015625-10.015624-10.015625s-10.015626 4.484375-10.015626 10.015625v90.554688c0 5.53125 4.484376 10.019531 10.015626 10.019531zm0 0" /></svg>
        )

        let eye = comp.isDeleted && comp.status === 0 ?
            <div>
                <Popover content="Deleted" trigger="hover">
                    <Icon className="cardNotes" component={deletedComp} />
                </Popover>
                <Popover content="Hidden" trigger="hover">
                    <Icon style={{ right: '60px' }} className="cardNotes" type="eye-invisible" />
                </Popover>
            </div>
            : comp.isDeleted ?
                <Popover content="Deleted" trigger="hover">    
                    <Icon className="cardNotes" component={deletedComp} />
                </Popover>
                : comp.status === 0 ?
                    <Popover content="Hidden" trigger="hover">        
                        <Icon className="cardNotes" type="eye-invisible" /> 
                    </Popover>
                        : ""

        let hierarchy = comp.companyParentCompanyId != null ?
            <Popover content="Son Element" trigger="hover">
                <svg className="iconRightCardBottom" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="658.49" height="661" viewBox="0 0 658.49 661">                    
                    <rect x="231.83" y="12.5" width="193" height="193" fill="#fff" stroke="#231f20" strokeMiterlimit="10" strokeWidth="25" />
                    <rect x="12.5" y="455.5" width="193" height="193" fill="#4a86c6" stroke="#231f20" strokeMiterlimit="10" strokeWidth="25" />
                    <rect x="452.99" y="455.5" width="193" height="193" fill="#fff" stroke="#231f20" strokeMiterlimit="10" strokeWidth="25" />
                    <line x1="328.33" y1="208.33" x2="328.33" y2="333.33" fill="none" stroke="#231f20" strokeMiterlimit="10" strokeWidth="25" />
                    <line x1="547.83" y1="323.69" x2="547.83" y2="448.69" fill="none" stroke="#231f20" strokeMiterlimit="10" strokeWidth="25" />
                    <line x1="111.83" y1="324.83" x2="111.83" y2="449.83" fill="none" stroke="#231f20" strokeMiterlimit="10" strokeWidth="25" />
                    <line x1="100.33" y1="337.17" x2="556.33" y2="336.17" fill="none" stroke="#231f20" strokeMiterlimit="10" strokeWidth="25" />
                </svg> 
            </Popover>
                : ""

        let noteIcon = () => (
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1024 1024" style={{ width: '1em', height: '1em', verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden' }}>
                <path d="M997.8,397l-92.5-92.5l-0.3-0.3c-12.3-12.1-32.2-12-44.4,0.2l-38.9,38.9V141.2C821.6,62.3,776.3,17,697.4,17H233.9
	                c-35.6,0-64.4,9.1-85.6,26.9c-18.8,15.9-30.9,38-35.9,65.8H48.5c-17.4,0-31.5,14.1-31.5,31.5c0,8.4,3.3,16.3,9.2,22.3
	                c6,6,13.9,9.2,22.3,9.2h61.2v122.3H48.5c-17.4,0-31.5,14.1-31.5,31.5c0,17.4,14.1,31.5,31.5,31.6h61.2v122.3H48.5
	                C31.1,480.5,17,494.6,17,512c0,8.4,3.3,16.3,9.2,22.3c6,6,13.9,9.2,22.3,9.2c0,0,0,0,0,0h61.2v122.3H48.5c-8.4,0-16.3,3.3-22.3,9.3
	                c-5.9,6-9.2,13.9-9.2,22.3c0,17.4,14.2,31.5,31.5,31.5c0,0,0,0,0,0h61.2v122.3H48.5c-8.4,0-16.3,3.3-22.3,9.3
	                c-5.9,6-9.2,13.9-9.2,22.3c0,17.4,14.2,31.5,31.5,31.5c0,0,0,0,0,0h63.8c5,27.8,17.1,49.9,35.9,65.8c21.2,17.9,50,26.9,85.6,26.9
	                h463.5c78.9,0,124.2-45.3,124.2-124.2v-265l176.2-176.2c5.9-6,9.2-13.9,9.2-22.3C1007,410.9,1003.7,403,997.8,397z M532.4,769.7
	                v-51.6l51.6,51.6H532.4z M697.4,943.9H233.9c-31.7,0-49.1-8.8-56.6-29.6H234c8.4,0,16.3-3.3,22.3-9.3c5.9-6,9.2-13.9,9.2-22.3
	                c0-17.4-14.2-31.5-31.5-31.5c0,0,0,0,0,0h-61.2V728.9h61.2c17.4,0,31.5-14.1,31.5-31.5c0-17.4-14.1-31.5-31.5-31.5h-61.2V543.5h61.2
	                c17.4,0,31.5-14.1,31.5-31.5c0-17.4-14.1-31.5-31.5-31.5h-61.2V358.2h61.2c17.4,0,31.5-14.1,31.5-31.5c0-8.4-3.3-16.3-9.2-22.3
	                s-13.9-9.2-22.3-9.2h-61.2V172.8h61.2c17.4,0,31.5-14.1,31.5-31.5c0-8.4-3.3-16.3-9.2-22.3c-6-6-13.9-9.2-22.3-9.2h-56.6
	                c7.5-20.8,24.9-29.6,56.6-29.6h463.5c44,0,61.2,17.1,61.2,61.2v265L489.8,674.9c-5.6,5.6-9,13-9.3,20.9l0,0.5v93.8
	                c0,17.4,14.1,31.5,31.5,31.5h93.2l3.2,0l0.5-0.3c6.4-0.9,12.4-3.7,17.2-8.1l0.9-0.9l131.6-131.6v201.9
	                C758.5,926.8,741.4,943.9,697.4,943.9z M838.2,512L614.8,735.4l-48.1-48.1l223.4-223.4L838.2,512z M930.9,419.3l-48.1,48.1
	                l-48.1-48.1l48.1-48.1L930.9,419.3z"/>
            </svg>
            )

        let notes = comp.notes != null && comp.notes !== '' ?
            <Popover content={comp.notes}>
                <Icon className="actionIcon noteIconHome" component={noteIcon} style={{ color: 'rgb(33, 58, 102)' }} />
            </Popover>
            :
            <Popover content="Notes">
                <Icon className="actionIcon noteIconHome" component={noteIcon} />
            </Popover>

        let typoIcon = comp.companyTypologyTrValue == 1 ? 
            <Popover content="Company">
                <svg className="iconRightCardBottom2" id="Layer_c" data-name="Layer c" viewBox="0 0 500 500">
                    <path style={{ fill: '#213a66' }} className="cls-1" d="M335.17,358.73Q309.63,372,271.63,372q-49.2,0-78.84-31.06T163.15,259.4q0-54.24,33.35-87.67t84.27-33.42q32.79,0,54.4,9.3v37.21a97.07,97.07,0,0,0-50.46-13.56q-36.73,0-59.52,23.49t-22.78,62.76q0,37.37,21.29,59.52t56,22.15q32,0,55.5-15.14Z" />
                    <path style={{ fill: '#1890ff' }} className="cls-2" d="M390.13,132.71V77h-275v55.71H37.33V441H468V132.71ZM133.52,423.56V94.44H371.79V423.56ZM54.9,150.41h60.27V423.3H54.9ZM450.07,423.3H390.13V150.41h59.94Z" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="188.43" width="27.86" height="27.86" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="244.14" width="27.86" height="27.86" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="188.43" width="27.86" height="27.86" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="244.14" width="27.86" height="27.86" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="299.86" width="27.86" height="27.86" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="299.86" width="27.86" height="27.86" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="356.5" width="27.86" height="27.86" />
                    <rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="356.5" width="27.86" height="27.86" />
                    </svg>
            </Popover>
            : comp.companyTypologyTrValue == 2 ? 
                <Popover content="Brand">
                    <svg className="iconRightCardBottom2" id="Layer_b" data-name="Layer b" viewBox="0 0 500 500">                       
                        <path style={{ fill: '#213a66' }} className="cls-1" d="M168.06,336V69h76Q278.65,69,299,85.94t20.3,44.13q0,22.73-12.29,39.47t-33.89,23.84v.74q27,3.16,43.2,20.39t16.2,44.78q0,34.26-24.58,55.48t-62,21.23ZM199.34,97.3v86.21h32q25.69,0,40.41-12.38t14.71-34.91q0-38.93-51.21-38.92Zm0,114.32V307.7h42.45q27.56,0,42.73-13t15.18-35.75q0-47.3-64.43-47.3Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M74.63,225a75.65,75.65,0,0,1,9,4.23l7.49-6.42a73.59,73.59,0,0,0,8.16-103.62L97.47,117l-10.85,9.21A73.56,73.56,0,0,0,74.63,225Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M51.73,234.14l-1.8,7.45a68.4,68.4,0,0,0,33,75.77A84.77,84.77,0,0,1,111,312.87a68.71,68.71,0,0,0-30.69-67.8l-.13-.09a59.47,59.47,0,0,0-12.92-6.43l-2.14-.76a63.14,63.14,0,0,0-6.11-1.85Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M137.19,384.8a84,84,0,0,1,38.17-9.69l-2.46-5.73a68.72,68.72,0,0,0-88.06-36.64c-.17.09-.76.32-1.3.53l-8,3.43,3,7A68,68,0,0,0,137.19,384.8Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M225.12,421.18l5.4-5.39-5.41-5.41a68.78,68.78,0,0,0-97.18,0l-5.4,5.41,5.4,5.39A68.79,68.79,0,0,0,225.12,421.18Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M415.39,225a75.65,75.65,0,0,0-9,4.23l-7.49-6.42a73.59,73.59,0,0,1-8.16-103.62l1.84-2.15,10.85,9.21A73.56,73.56,0,0,1,415.39,225Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M438.29,234.14l1.8,7.45a68.4,68.4,0,0,1-33,75.77A84.77,84.77,0,0,0,379,312.87,68.7,68.7,0,0,1,409.67,245l.13-.09a59.47,59.47,0,0,1,12.92-6.43l2.14-.76a63.14,63.14,0,0,1,6.11-1.85Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M352.83,384.8a84,84,0,0,0-38.18-9.69l2.47-5.73a68.71,68.71,0,0,1,88.09-36.6c.17.09.77.31,1.3.53l8,3.44-3.05,7.05A68,68,0,0,1,352.83,384.8Z" />
                        <path style={{ fill: '#1890ff' }} className="cls-2" d="M264.9,421.18l-5.4-5.39,5.41-5.41a68.78,68.78,0,0,1,97.18,0l5.4,5.41-5.4,5.39A68.79,68.79,0,0,1,264.9,421.18Z" />
                    </svg>
                </Popover>
                : comp.companyTypologyTrValue == 17 ? 
                    <Popover content="Sign">
                        <svg className="iconRightCardBottom2" id="Layer_s" data-name="Layer s" viewBox="0 0 500 500">
                            <path style={{ fill: '#1890ff' }} className="cls-1" d="M431,179.5v168H69v-168H431m19-19H50v206H450v-206Z" />
                            <path style={{ fill: '#213a66' }} className="cls-2" d="M334.28,124.68q-29.92-13.11-67.85-13.11A159.14,159.14,0,0,0,225,117a117.34,117.34,0,0,0-35.78,16.11,83.37,83.37,0,0,0-25.09,26.52q-9.41,15.81-9.41,36.35,0,16.81,5,29.36a65.76,65.76,0,0,0,14.83,22.38A102.57,102.57,0,0,0,199,265.38a336.53,336.53,0,0,0,34.06,15.53q14,5.43,26.09,10.41a110.07,110.07,0,0,1,21.1,11.26A52.64,52.64,0,0,1,294.51,317q5.28,8.11,5.28,19.81,0,41.06-61.58,41A136.24,136.24,0,0,1,182,366H154.1v33.79q33.08,17.4,78.12,17.4a181.21,181.21,0,0,0,43.62-5.14,116.63,116.63,0,0,0,36.77-15.68,81.73,81.73,0,0,0,25.52-26.51q9.56-16,9.55-37.63,0-17.67-5.84-30.51a69.2,69.2,0,0,0-16.68-22.66,119.59,119.59,0,0,0-26.23-17.68,364.93,364.93,0,0,0-34.78-15.25q-14.53-5.7-25.94-10.55a92.42,92.42,0,0,1-19.39-10.83,42.05,42.05,0,0,1-12.12-13.69q-4.12-7.69-4.13-19.1a34.19,34.19,0,0,1,4.13-16.67,38.94,38.94,0,0,1,11.69-13,58.27,58.27,0,0,1,18.11-8.41,86.75,86.75,0,0,1,23.66-3q29,0,53.31,10.09h20.81Z" />
                        </svg>
                    </Popover>
                    : comp.companyTypologyTrValue == 20 ? 
                        <Popover content="Department">
                            <svg className="iconRightCardBottom2" id="Layer_d" data-name="Layer d" viewBox="0 0 500 500">
                                <polygon style={{ fill: '#1890ff' }} className="cls-1" points="481.25 69 248.08 69 248.08 83.59 432.6 83.59 432.6 302.16 481.25 302.16 481.25 69" />
                                <polygon style={{ fill: '#1890ff' }} className="cls-1" points="86.85 207.84 39.3 207.84 39.3 441 272.46 441 272.46 420.34 86.85 420.34 86.85 207.84" />
                                <path style={{ fill: '#1890ff' }} className="cls-2" d="M416.27,99V411h-312V99h312m17-17h-346V428h346V82Z" />
                                <path style={{ fill: '#213a66' }} className="cls-1" d="M155.9,379V131h71.6q137.14,0,137.14,120.89,0,57.42-38.05,92.26T224.56,379Zm36-220.17V351.34H227.4q46.87,0,72.92-25.77t26-72.82q0-93.92-97.28-93.92Z" />
                            </svg>
                        </Popover>
                        : ""

        let deleteIcon = comp.isDeleted == 1 ?
            <Popconfirm title="Are you sure to delete this company, its sons and all of its components?" okText="Yes" cancelText="No" onConfirm={() => this.deleteComp(comp.companyId, 2)} >
                <Icon type="close" className="blueIcon" />
            </Popconfirm>
            :
            <Popconfirm title="Are you sure to move this item to the bin?" okText="Yes" cancelText="No" onConfirm={() => this.deleteComp(comp.companyId, 1)} >
                <Popover content="Delete" trigger="hover">
                    <Icon type="delete" className="blueIcon" />
                </Popover>
            </Popconfirm>

        let revert = comp.isDeleted == 1 ?
            <Popconfirm title="Are you sure to restore this company?" okText="Yes" cancelText="No" onConfirm={this.revertComp} >
                <Popover content="Restore" trigger="hover">
                    <Icon className="blueIcon" type="rollback" />
                </Popover>
            </Popconfirm>
            :
            <Link to={"/edit?id=" + comp.companyId} >
                <Popover content="Edit" trigger="hover">
                    <Icon className="actionIcon" type="edit" className="blueIcon" />
                </Popover>
            </Link>

        return (
            <Card
                actions={[<div> {revert} {deleteIcon}</div>, <div>{bookmark} {notes}</div>]}
            >
                {eye}
                {immagine}
                {hierarchy}
                {typoIcon}
                <h3 onClick={() => this.props.getDetail(comp.companyId, false)} className={"firstLevel fakeLink " + linea}>{comp.name}</h3>
                {category}
            </Card>
        )
    }

}

export default CardLite;


// WEBPACK FOOTER //
// ./src/util/compCardLite.js